<ng-container [formGroup]="pepPartnerList">
    <div class="ba-field-group">
        <ibk-input-group>
            <label>Entidad a la que pertenece (*)</label>
            <ibk-input class="field">
                <input class="field" formControlName="pepEntity" maxlength="20" />
            </ibk-input>
        </ibk-input-group>
        <ibk-input-group>
            <label>Cargo que posee(*)</label>
            <ibk-input class="field">
                <input class="field" formControlName="pepPosition" maxlength="20" />
            </ibk-input>
        </ibk-input-group>
    </div>
    <div class="ba-field-group">
        <ibk-input-group>
            <label>Fecha de inicio de labores (*)</label>
            <ibk-input icon="event">
                <input class="input-date-picker" readonly #starDate appDatePickerControl
                    formControlName="pepStartDate" />
                <ibk-date-picker [el]="starDate" [config]="ibkConfig"></ibk-date-picker>
            </ibk-input>
        </ibk-input-group>
        <ibk-input-group>
            <label>Fecha de fin de labores (*)</label>
            <ibk-input icon="event">
                <input class="input-date-picker" readonly #endDate appDatePickerControl formControlName="pepEndDate" />
                <ibk-date-picker [el]="endDate" [config]="ibkConfig"></ibk-date-picker>
            </ibk-input>
        </ibk-input-group>
    </div>
    <ibk-toast type="ERROR" *ngIf="pepPartnerList.touched && pepPartnerList.invalid">
        Por favor agregue una fecha v&aacute;lida de inicio y fin de labores
    </ibk-toast>
</ng-container>